export default __webpack_public_path__ + "7e348f344a4508f6e492a17e90162dc2.svg";